import React from 'react';
import { Icon } from './Icon.js';
export const IconWindowTopRightFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M2.75 1C1.23122 1 0 2.23122 0 3.75V8.25C0 9.76878 1.23122 11 2.75 11H9.25C10.7688 11 12 9.76878 12 8.25V3.75C12 2.23122 10.7688 1 9.25 1H2.75ZM9.25 3C9.66421 3 10 3.33579 10 3.75V5.75C10 6.16421 9.66421 6.5 9.25 6.5H7.25C6.83579 6.5 6.5 6.16421 6.5 5.75V3.75C6.5 3.33579 6.83579 3 7.25 3H9.25Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconWindowTopRightFill12.js.map